import React from 'react';
import {
  Button,
  Heading,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@alefeducation/ui-elements-library-core';
import { Times } from '@alefeducation/ui-elements-library-icons';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

interface Navigation {
  path: string;
  context: any;
}

interface Props {
  open: boolean;
  modalVisibility: (val: boolean) => void;
  heading: string;
  message: string;
  redirectUrlOnYes?: string;
  yesButtonText?: string;
  noButtonText?: string;
  navigation?: Navigation;

  onYesClick?(e: any): void;
}

const StyledHeaderContainer = styled.div`
  margin-bottom: ${({ theme: { space } }: any) => `${space[14]}px`};
`;

const StyledMessage = styled(Heading)`
  word-break: break-word;
`;

export const ConfirmModal: React.FC<Props> = ({
  open,
  modalVisibility = () => {},
  heading,
  message,
  redirectUrlOnYes,
  onYesClick,
  yesButtonText = 'Yes',
  noButtonText = 'No',
  navigation,
}) => {
  const history = useHistory();
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Modal
        data-testid={'confirm-modal'}
        open={open}
        handleBackdropClick={() => {}}
      >
        <StyledHeaderContainer>
          <ModalHeader>
            <Times
              height="14"
              width="14"
              color="primary.40"
              cursor="pointer"
              onClick={(e) => {
                e.stopPropagation();
                modalVisibility(false);
              }}
            />
          </ModalHeader>
        </StyledHeaderContainer>
        <ModalContent>
          <StyledHeaderContainer>
            <Heading variant="heading-xl" weight="bold" color="text100">
              {heading}
            </Heading>
          </StyledHeaderContainer>
          <StyledMessage variant="heading-small" weight="light" color="text100">
            {message}
          </StyledMessage>
        </ModalContent>
        <ModalActions>
          <Button
            variant="secondary"
            onClick={(e) => {
              e.stopPropagation();
              modalVisibility(false);
            }}
          >
            {noButtonText}
          </Button>
          <Button
            onClick={(e: any) => {
              if (navigation) {
                history.push(navigation.path, navigation.context);
              } else if (onYesClick) {
                onYesClick(e);
                e.stopPropagation();
              }
            }}
          >
            {yesButtonText}
          </Button>
        </ModalActions>
      </Modal>
    </div>
  );
};
